import styles from '@/styles/footer.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import getConfig from 'next/config'
import { Button, Input } from 'antd';
const { publicRuntimeConfig } = getConfig();
const apiDomain = publicRuntimeConfig.apiDomain;
const imageDomain = publicRuntimeConfig.imageDomain
import FollowiconFb from '@/svgs/share-icon/Followicon-fb.svg'
import FollowiconX from '@/svgs/share-icon/Followicon-x.svg'
import FollowiconPin from '@/svgs/share-icon/Followicon-pin.svg'
import FollowiconBr from '@/svgs/share-icon/Followicon-br.svg'
import FollowiconTiktop from '@/svgs/share-icon/Followicon-tt.svg'
import FollowiconIns from '@/svgs/share-icon/Followicon-ins.svg'
import FollowiconThreads from '@/svgs/share-icon/Followicon-threads.svg'
import { useEffect, useState } from 'react';
import systemApi from '@/service/modules/systemApi';
import { ZIP_PAYMENT_ENABLED } from '@/utils/paymentMethods';

export default function Footer() {
  const router = useRouter()
  const pathname = router.asPath || ''
  const currentYear = new Date().getFullYear(); // 获取当前年份
  function handlePageJump(url: string, e: any) {
    // 阻止a标签默认行为
    e.preventDefault()

    window.location.href = `${url}`
  }

  // 蜜罐链接仅在指定页面生效
  const honeypotPrefixPaths = [
    '/online-',
    '/search/',
    '/shop/',
    '/article/return',
    '/bestdealoftheday',
    '/top-seller',
    '/clearance',
    '/newarrival',
    '/free-shipping',
    '/hottest-deals',
    '/featured-deals',
    '/top-reviewed-1'
  ]
  const showHoneypot =
    pathname === '/' ||
    pathname.startsWith('/?') ||
    pathname.startsWith('/#') ||
    honeypotPrefixPaths.some((prefix) => pathname.startsWith(prefix))

  const helpData = [
    {
      title: 'Company Info',
      helpList: [
        { title: 'About Us', link: `${apiDomain}/article/AboutUs` },
        { title: 'Terms & Conditions', link: '/article/terms' },
        { title: 'Privacy Statement', link: '/article/privacy' },
        { title: 'Warranty Policy', link: '/article/warranty' },
        { title: 'Site Map', link: '/sitemap' }
      ]
    }, {
      title: 'Customer Service',
      helpList: [
        { title: 'Contact Us', link: '/contact-us' },
        { title: 'My Account', link: '/my-account' },
        { title: 'Frequently Asked Questions(FAQ)', link: '/article/faq' },
        { title: 'Afterpay', link: '/afterpay' },
        ...(ZIP_PAYMENT_ENABLED
          ? [{ title: 'Zippay', link: 'https://zip.co/nz/how-it-works/' }]
          : [])
      ]
    }, {
      title: 'Shipping & Returns',
      helpList: [
        { title: 'Shipping Guide', link: '/article/shipping' },
        { title: 'Return & Refund Policy', link: '/article/return' },
        { title: 'Track Your Order', link: '/my-account/order/all' }
      ]
    }
  ]
  const helpItems = helpData.map(item =>
    <div key={item.title} className={styles['help-item']}>
      <div className={styles['help-title']}>{item.title}</div>
      <ul className={styles['child-list']}>
        {
          item.helpList.map(help => (
            <li key={help.link}>
              <Link
                key={help.title}
                href={help.link}
                passHref
                legacyBehavior
              >
                <a
                  onClick={(e: any) => handlePageJump(`${help.link}`, e)}
                  rel="noopener noreferrer"
                >{help.title}</a>
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  )

  const followList = [
    {
      compoent: FollowiconFb,
      url: 'https://www.facebook.com/bestdeals.co.nz'
    },
    {
      compoent: FollowiconX,
      url: 'https://x.com/BestDealsCoNz'
    },
    {


      compoent: FollowiconPin,
      url: 'https://www.pinterest.com/bestdealsconz/'
    },
    {
      compoent: FollowiconBr,
      url: 'http://blog.bestdeals.co.nz/'
    },
    {
      compoent: FollowiconTiktop,
      url: 'https://www.tiktok.com/@bestdealsnz'
    },
    {
      compoent: FollowiconIns,
      url: 'https://www.instagram.com/bestdealsnz/'
    },
    {
      compoent: FollowiconThreads,
      url: 'https://www.threads.net/@bestdealsnz'
    }
  ]

  const payIcon = [
    { name: 'VISA', src: 'https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/VISA.svg', width: 50, height: 32 },
    { name: 'Mastercard', src: 'https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/Mastercard.svg', width: 50, height: 32 },
    { name: 'Paypal', src: 'https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/Paypal.svg', width: 50, height: 32 },
    { name: 'Afterpay', src: 'https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/afterpay-logo.svg', width: 50, height: 32 },
    ...(ZIP_PAYMENT_ENABLED
      ? [{ name: 'Zip', src: 'https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/Zip.svg', width: 50, height: 32 }]
      : []),
    { name: 'ApplePay', src: 'https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/Applepay.svg', width: 50, height: 32 },
    { name: 'GooglePay', src: 'https://img.bestdeals.co.nz/images/next/images/svg/pay-icon/google-pay.svg', width: 50, height: 32 }
  ]

  const [middleSubscribeValue, setMiddleSubscribeValue] = useState("")
  const [subscribeBanner, setSubscribeBanner] = useState("")

  useEffect(() => {
    getBanner()
  }, [])

  const getBanner = async () => {
    try {
      // const res = await systemApi.getFullBanners({ home: "homepageBottomBanner" })
      const res = await systemApi.getFullBanners()
      const { homepageBottomBanner } = res.data.home
      setSubscribeBanner(homepageBottomBanner ? homepageBottomBanner.imgUrl : `${imageDomain}/subscribe/subscribe-footer.png`)
    } catch (error: any) {
      console.log(error.message);

    }
  }

  const handleMiddleSubscribeChange = (event: any) => {
    setMiddleSubscribeValue(event.target.value)
  }

  const handleSendSubscribe = () => {
    window.location.href = `https://${window.location.host}/newsletters?email=${middleSubscribeValue}`
  }

  return (
    <>
      <div className={styles['footer-box']} id="footerBox">
        <div className={styles['help-box']}>
          <div className={styles['subscribe-box']}>
            {
              subscribeBanner
              &&
              <Link legacyBehavior href={'/newsletters'}>
                <a rel="noopener noreferrer">
                  <Image src={subscribeBanner} alt="subscribe" width={631} height={122} layout="intrinsic" />
                </a>
              </Link>
            }
            <div className={styles['subscribeForm']}>
              <Input value={middleSubscribeValue} onChange={handleMiddleSubscribeChange} className={styles['subscribeForm-input']} placeholder='Email Address' />
              <Button className={styles['subscribeForm-btn']} onClick={handleSendSubscribe}>Subscribe</Button>
            </div>
          </div>
          <div className={styles['content']}>
            {helpItems}

            <div className={styles['help-item']}>
              <div className={styles['help-title']}>Follow Us</div>
              <div className={styles['follow-list']}>
                {
                  followList.map(item =>
                    <div className={styles['followItem']} key={item.url}>
                      <Link href={item.url} passHref legacyBehavior><a rel="noopener noreferrer" target="_blank"><item.compoent /></a></Link>
                    </div>)
                }
              </div>
              <div className={styles['help-title']}>Secured By</div>
              <Image src={`${imageDomain}/verified&secured.png`} width={132} height={32} layout="intrinsic" alt='verified&secured' />
            </div>

            <div className={styles['help-item']}>
              <div className={styles['help-title']}>We Acceept</div>
              <div className={styles['acceept-list']}>
                {
                  payIcon.map(icon =>
                    <div className={styles['acceeptItem']} key={icon.name}>
                      <Image 
                        className={styles['acceept-icon']}
                        src={icon.src} 
                        alt={icon.name} 
                        width={icon.width} 
                        height={icon.height}
                        style={icon.name === 'ApplePay' || icon.name === 'GooglePay' ? { objectFit: 'cover' } : undefined}
                      />
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles['copyright']}>© Copyright 2012 - {currentYear} Best Deals Store. All Rights Reserved.</div>

      {showHoneypot && (
          <a
            href="/whycanseeme.html"
            rel="nofollow"
            style={{ display: "none" }}
            aria-hidden
          ></a>
        )}
    </>
  )
}
